//
//
//
//
//
//
//
//

 import SchemaTest from './components/SchemaTest.vue'
 import PlainComponents from './components/PlainComponents.vue'
 import ContractManager from './components/ContractManager.vue'


export default {
  name: 'LayoutDefault',

  components: {
      SchemaTest,
      PlainComponents,
      ContractManager
  }
}
